import { signal } from '@preact/signals-react';

export const carregandoSignal = signal(true);